import isElement from './is-element.js';

export default function findSingle(element, selector) {
  return isElement(element)
    ? (element.matches(selector) ? element : element.querySelector(selector))
    : null;
}
